// TODO: vitest component test (pages are covered by Playwright e2e)
import { useNavigate, useSearchParams, useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader, Breadcrumbs } from '@/components/layout'
import { Card, Skeleton } from '@/components/ui'
import { LeaseFields } from '@/components/leases/LeaseFields'
import { useLease } from '@/hooks/useLeases'
import { track } from '@/lib/analytics'
import type { Lease } from '@/types'

export function LeaseFormPage() {
  const { t } = useTranslation('leases')
  const { t: tc } = useTranslation('common')
  const { id } = useParams<{ id: string }>()
  const isEdit = !!id
  const leaseId = Number(id)
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  // Read default IDs from URL query params (wizard / deep-link support)
  const defaultUnitId = searchParams.get('unit_id') ? Number(searchParams.get('unit_id')) : undefined
  const defaultCustomerId = searchParams.get('customer_id') ? Number(searchParams.get('customer_id')) : undefined

  const { data: lease, isLoading: isLoadingLease } = useLease(leaseId)

  const handleSave = (saved: Lease) => {
    // C4 — feature_used event: lease creation/edit is a key activation signal.
    track('feature_used', { feature: isEdit ? 'lease_update' : 'lease_create' })
    navigate(`/leases/${saved.id}`)
  }

  if (isEdit && isLoadingLease) {
    return (
      <div className="space-y-6">
        <Skeleton className="h-8 w-64" />
        <Card>
          <Skeleton className="h-96" />
        </Card>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <Breadcrumbs
        items={[
          { label: t('title'), href: '/leases' },
          ...(isEdit && lease ? [{ label: lease.lease_code, href: `/leases/${leaseId}` }] : []),
          { label: isEdit ? tc('actions.edit') : t('new_lease') },
        ]}
      />

      <PageHeader
        title={isEdit ? t('edit_lease') : t('new_lease')}
        description={isEdit ? t('edit_description') : t('new_description')}
      />

      <LeaseFields
        lease={isEdit ? (lease ?? null) : null}
        defaultUnitId={defaultUnitId}
        defaultCustomerId={defaultCustomerId}
        onSave={handleSave}
        onCancel={() => navigate(-1)}
      />
    </div>
  )
}
